import { Api } from '../../../core/api';

type FetchUsersParams = {
  userTypes: string[];
  pagination: {
    page: number;
    limit: number;
  };
  searchPhrase: string;
  isActiveUser: boolean;
};

export const usersListApi = new Api({
  useEagleApi: true,
  namespace: 'USERS_LIST',
  url: '/internal-intranet/search/users',
});

export const fetchUsers = ({
  userTypes,
  pagination,
  searchPhrase,
  isActiveUser,
}: FetchUsersParams) => {
  const filters = [];

  if (searchPhrase) {
    filters.push({
      property: 'name',
      type: 'containsIgnoreCase',
      value: searchPhrase,
    });
    filters.push({
      property: 'username',
      type: 'containsIgnoreCase',
      value: searchPhrase,
    });
  }

  if (!searchPhrase && userTypes.length > 0) {
    filters.push({
      property: 'type',
      type: 'in',
      value: userTypes.join(','),
    });
  }

  if (!searchPhrase && userTypes.length > 0 && isActiveUser) {
    filters.push({
      property: 'status',
      type: 'eq',
      value: isActiveUser,
    });
  }

  const body = JSON.stringify({
    page: pagination.page,
    pageSize: pagination.limit,
    sort: { order: [{ direction: 'ASC', property: 'name' }] },
    filter:
      filters.length > 0
        ? {
            filters,
          }
        : null,
  });

  return usersListApi.fetch({
    options: {
      method: 'POST',
      body,
    },
  });
};

export const reducer = usersListApi.reducer;
